import React, { useState, useEffect } from "react";
import { Download, Scale, RefreshCw } from "lucide-react";
import { api } from "../../utils/api";
import * as XLSX from "xlsx"; 

export default function Balances() {
  const [transactions, setTransactions] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [activePeriod, setActivePeriod] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/periods").then(r => {
      const data = r.data || [];
      setPeriods(data);
      const active = data.find(p => p.active || p.is_active);
      if (active) setActivePeriod(active.name);
      else if (data.length > 0) setActivePeriod(data[0].name);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (activePeriod) load();
  }, [activePeriod]);

  const load = () => {
    setLoading(true);
    Promise.all([
      api.get("/transactions"),
      api.get("/transfers"),
      api.get("/dashboard")
    ]).then(([resTx, resTr, resDash]) => {
      setTransactions(resTx.data || []);
      setTransfers(resTr.data || []);
      setDashboardData(resDash.data || {});
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  // 1. SEÇİLİ DÖNEMİN FİLTRELENMESİ
  const currentTransactions = transactions.filter(t => !t.period || t.period === activePeriod);
  const currentTransfers = transfers.filter(t => !t.period || t.period === activePeriod);

  const incomes = currentTransactions.filter(t => t.kind === "income");
  const expenses = currentTransactions.filter(t => t.kind === "expense");

  // 2. GİDERLER (AKTİF) - ANA HESAP GRUPLANDIRMASI
  const groupedExpenses = {
    740: { title: "740 Hizmet Üretim Maliyeti", total: 0, items: {} },
    254: { title: "254 Taşıtlar", total: 0, items: {} },
    255: { title: "255 Demirbaşlar", total: 0, items: {} }
  };

  expenses.forEach(t => {
    const rawCat = t.category || "Diğer Giderler";
    const catLower = rawCat.toLowerCase();
    
    let mainGroup = 740;
    let displayCat = rawCat;

    if (/^740/.test(rawCat)) { 
      mainGroup = 740; displayCat = rawCat; 
    } else if (/^254/.test(rawCat)) { 
      mainGroup = 254; displayCat = rawCat; 
    } else if (/^255/.test(rawCat)) { 
      mainGroup = 255; displayCat = rawCat; 
    } else {
      if (catLower.includes("personel") || catLower.includes("bahçıvan") || catLower.includes("maaş")) {
        mainGroup = 740; displayCat = "740.03 Site Personel Gideri";
      } else if (catLower.includes("sgk") || catLower.includes("vergi")) {
        mainGroup = 740; displayCat = "740.06 Vergi ve SGK İşveren Payları";
      } else if (catLower.includes("taşıt") || catLower.includes("araç")) {
        mainGroup = 254; displayCat = `254.01 ${rawCat}`;
      } else if (catLower.includes("demirbaş") || catLower.includes("kamera") || catLower.includes("ocak") || catLower.includes("çöp")) {
        mainGroup = 255; displayCat = `255.01 ${rawCat}`;
      } else {
        mainGroup = 740;
        let sub = "01";
        if (catLower.includes("elektrik")) sub = "02";
        if (catLower.includes("traktör") || catLower.includes("yükleme")) sub = "04";
        if (catLower.includes("iletişim")) sub = "05";
        if (catLower.includes("noter") || catLower.includes("avukat")) sub = "07";
        displayCat = `740.${sub} ${rawCat}`;
      }
    }

    groupedExpenses[mainGroup].total += t.amount;
    groupedExpenses[mainGroup].items[displayCat] = (groupedExpenses[mainGroup].items[displayCat] || 0) + t.amount;
  });

  const totalExpense = expenses.reduce((sum, t) => sum + t.amount, 0);

  // 3. GELİRLER (PASİF)
  const incomeCats = {
    "600.01 Aidat Gelirleri": 0,
    "600.02 Gecikme Tazminatları": 0,
    "600.03 Diğer Gelirler": 0
  };

  incomes.forEach(t => {
    const cat = (t.category || "").toLowerCase();
    if (cat.includes("devir")) return; 
    if (cat.includes("aidat")) incomeCats["600.01 Aidat Gelirleri"] += t.amount;
    else if (cat.includes("gecikme") || cat.includes("tazminat")) incomeCats["600.02 Gecikme Tazminatları"] += t.amount;
    else incomeCats["600.03 Diğer Gelirler"] += t.amount;
  });

  const donemGeliri = Object.values(incomeCats).reduce((a, b) => a + b, 0);

  // 4. ÖNCEKİ DÖNEMDEN DEVİR (AÇILIŞ BAKİYELERİ)
  const devirKayitlari = currentTransfers.filter(t => t.from_account === "Devir");
  const devirKasa = devirKayitlari.filter(t => t.to_account === "Kasa" || t.to_account === "Nakit").reduce((s, t) => s + t.amount, 0);
  const devirIsBankasi = devirKayitlari.filter(t => t.to_account === "İş Bankası").reduce((s, t) => s + t.amount, 0);
  const devirZiraat = devirKayitlari.filter(t => t.to_account === "Ziraat Bankası").reduce((s, t) => s + t.amount, 0);
  
  const totalDevir = devirKasa + devirIsBankasi + devirZiraat;
  const totalIncome = donemGeliri + totalDevir;

  // 5. HAZIR DEĞERLER (KAPANIŞ BAKİYELERİ) - MATEMATİKSEL KUSURSUZ EŞİTLİK
  const inKasa = incomes.filter(t => t.payment_method === "Kasa" || t.payment_method === "Nakit").reduce((s, t) => s + t.amount, 0);
  const inIsBank = incomes.filter(t => t.payment_method === "İş Bankası").reduce((s, t) => s + t.amount, 0);
  const inZiraat = incomes.filter(t => t.payment_method === "Ziraat Bankası" || t.payment_method === "Ziraat").reduce((s, t) => s + t.amount, 0);

  const outKasa = expenses.filter(t => t.payment_method === "Kasa" || t.payment_method === "Nakit").reduce((s, t) => s + t.amount, 0);
  const outIsBank = expenses.filter(t => t.payment_method === "İş Bankası").reduce((s, t) => s + t.amount, 0);
  const outZiraat = expenses.filter(t => t.payment_method === "Ziraat Bankası" || t.payment_method === "Ziraat").reduce((s, t) => s + t.amount, 0);

  const icTransferler = currentTransfers.filter(t => t.from_account !== "Devir");
  const trInKasa = icTransferler.filter(t => t.to_account === "Kasa" || t.to_account === "Nakit").reduce((s, t) => s + t.amount, 0);
  const trOutKasa = icTransferler.filter(t => t.from_account === "Kasa" || t.from_account === "Nakit").reduce((s, t) => s + t.amount, 0);

  const trInIsBank = icTransferler.filter(t => t.to_account === "İş Bankası").reduce((s, t) => s + t.amount, 0);
  const trOutIsBank = icTransferler.filter(t => t.from_account === "İş Bankası").reduce((s, t) => s + t.amount, 0);

  const trInZiraat = icTransferler.filter(t => t.to_account === "Ziraat Bankası" || t.to_account === "Ziraat").reduce((s, t) => s + t.amount, 0);
  const trOutZiraat = icTransferler.filter(t => t.from_account === "Ziraat Bankası" || t.from_account === "Ziraat").reduce((s, t) => s + t.amount, 0);

  const hazirKasa = devirKasa + inKasa - outKasa + trInKasa - trOutKasa;
  const hazirIsBank = devirIsBankasi + inIsBank - outIsBank + trInIsBank - trOutIsBank;
  const hazirZiraat = devirZiraat + inZiraat - outZiraat + trInZiraat - trOutZiraat;

  const totalHazirDeger = hazirKasa + hazirIsBank + hazirZiraat;

  // 6. AİDAT ALACAKLARI & TAHAKKUKLARI (Dashboard'dan çekilip Aktif ve Pasif'e eşit dağıtılır)
  const aidatAlacaklari = dashboardData?.pending_dues || 0;

  const aktifToplam = totalExpense + totalHazirDeger + aidatAlacaklari;
  const pasifToplam = totalIncome + aidatAlacaklari;

  // --- TABLO VERİSİ OLUŞTURMA (Sağ-Sol Eşleme) ---
  const leftRows = [];
  
  // SOL Taraf - 1: Giderler (740, 254, 255)
  leftRows.push({ name: "GİDERLER", amount: null, ratio: null, bold: true });
  [740, 254, 255].forEach(code => {
    if (groupedExpenses[code].total > 0 || Object.keys(groupedExpenses[code].items).length > 0) {
      leftRows.push({ name: groupedExpenses[code].title, amount: groupedExpenses[code].total, ratio: totalExpense, bold: true, highlight: false });
      Object.entries(groupedExpenses[code].items).forEach(([name, amount]) => {
        leftRows.push({ name: `   ${name}`, amount: amount, ratio: totalExpense });
      });
    }
  });
  leftRows.push({ name: "TOPLAM GİDERLER", amount: totalExpense, ratio: null, bold: true, highlight: true });
  leftRows.push({ name: "", amount: null, ratio: null });

  // SOL Taraf - 2: Alacaklar (120)
  leftRows.push({ name: "ALACAKLAR", amount: aidatAlacaklari, ratio: null, bold: true });
  leftRows.push({ name: "  120 - Aidat Alacakları", amount: aidatAlacaklari, ratio: null });
  leftRows.push({ name: "", amount: null, ratio: null });
  
  // SOL Taraf - 3: Hazır Değerler (100, 102)
  leftRows.push({ name: "HAZIR DEĞERLER (Kapanış Bakiyesi)", amount: totalHazirDeger, ratio: null, bold: true });
  leftRows.push({ name: "  100.01 - Kasa", amount: hazirKasa, ratio: null });
  leftRows.push({ name: "  102.01 - İş Bankası", amount: hazirIsBank, ratio: null });
  leftRows.push({ name: "  102.02 - Ziraat Bankası", amount: hazirZiraat, ratio: null });
  
  const rightRows = [];

  // SAĞ Taraf - 1: Devir
  rightRows.push({ name: "ÖNCEKİ DÖNEMDEN DEVİR (Açılış Bakiyesi)", amount: totalDevir, ratio: totalIncome, bold: true });
  rightRows.push({ name: "  100.01 - Kasa (Devir)", amount: devirKasa, ratio: null });
  rightRows.push({ name: "  102.01 - İş Bankası (Devir)", amount: devirIsBankasi, ratio: null });
  rightRows.push({ name: "  102.02 - Ziraat Bankası (Devir)", amount: devirZiraat, ratio: null });
  rightRows.push({ name: "", amount: null, ratio: null });
  
  // SAĞ Taraf - 2: Gelirler
  rightRows.push({ name: "GELİRLER", amount: donemGeliri, ratio: totalIncome, bold: true });
  Object.entries(incomeCats).forEach(([name, amount]) => {
    rightRows.push({ name: `  ${name}`, amount, ratio: donemGeliri });
  });
  rightRows.push({ name: "TOPLAM GELİRLER", amount: totalIncome, ratio: null, bold: true, highlight: true });
  rightRows.push({ name: "", amount: null, ratio: null });

  // SAĞ Taraf - 3: Tahakkuklar (181)
  rightRows.push({ name: "GELİR TAHAKKUKLARI", amount: aidatAlacaklari, ratio: null, bold: true });
  rightRows.push({ name: "  181 - Aidat Alacakları (Tahakkuk)", amount: aidatAlacaklari, ratio: null });
  
  const maxRowsCount = Math.max(leftRows.length, rightRows.length);
  const rows = [];
  
  for (let i = 0; i < maxRowsCount; i++) {
    rows.push({
      left: leftRows[i] || { name: "", amount: null, ratio: null },
      right: rightRows[i] || { name: "", amount: null, ratio: null }
    });
  }

  rows.push({
    left: { name: "", amount: null, ratio: null },
    right: { name: "", amount: null, ratio: null }
  }); 
  rows.push({
    left: { name: "AKTİF TOPLAM", amount: aktifToplam, ratio: null, bold: true, highlight: true },
    right: { name: "PASİF TOPLAM", amount: pasifToplam, ratio: null, bold: true, highlight: true }
  });

  const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(n || 0);
  const percent = (val, total) => total && val ? ((val / total) * 100).toFixed(2) + "%" : "";

  const exportToExcel = () => {
    const table = document.getElementById("bilanco-table");
    const wb = XLSX.utils.table_to_book(table, { sheet: "Bilanço" });
    XLSX.writeFile(wb, `${activePeriod}_Donemi_Bilanco_Raporu.xlsx`);
  };

  return (
    <div style={{ animation: "fadeIn 0.4s ease-out" }}>
      
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", background: "white", padding: "24px 30px", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", marginBottom: "24px", gap: "20px" }}>
        <div>
          <span style={{ fontSize: "12px", fontWeight: "bold", color: "#8b5cf6", letterSpacing: "1px", textTransform: "uppercase" }}>FİNANSAL ÖZET</span>
          <h2 style={{ margin: "6px 0", fontSize: "24px", color: "#1e293b", display: "flex", alignItems: "center", gap: "8px" }}>
            <Scale size={26} color="#8b5cf6" /> Dönem Bilançosu
          </h2>
          <p style={{ margin: 0, fontSize: "14px", color: "#64748b" }}>TDHP hesap kodlarına göre tasnif edilmiş Dönem İçi Aktif/Pasif dengesi.</p>
        </div>
        
        <div style={{ display: "flex", gap: "12px" }}>
          <select value={activePeriod} onChange={e => setActivePeriod(e.target.value)} style={{ padding: "10px 16px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", background: "#f8fafc", fontWeight: "bold", cursor: "pointer" }}>
            {periods.map(p => (
              <option key={p.id} value={p.name}>{p.name}</option>
            ))}
            {!periods.length && <option value="Dönem Bulunamadı">Dönem Bulunamadı</option>}
          </select>

          <button onClick={load} style={{ background: "white", border: "1px solid #cbd5e1", padding: "12px", borderRadius: "10px", cursor: "pointer", color: "#475569" }}>
            <RefreshCw size={18} className={loading ? "spin" : ""} />
          </button>
          <button onClick={exportToExcel} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#10b981", color: "white", border: "none", padding: "12px 22px", borderRadius: "10px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 4px 12px rgba(16, 185, 129, 0.25)" }}>
            <Download size={18} /> Excel'e Aktar
          </button>
        </div>
      </div>

      <div style={{ background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", overflowX: "auto", paddingBottom: "10px" }}>
        {loading ? (
          <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>Bilanço hesaplanıyor...</div>
        ) : (
          <table id="bilanco-table" style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: "900px" }}>
            <thead>
              <tr style={{ background: "#1e293b", color: "white" }}>
                <th style={{ padding: "14px 16px", textAlign: "left", width: "30%" }}>AKTİF (Dönen & Duran Varlıklar)</th>
                <th style={{ padding: "14px 16px", textAlign: "right", width: "12%" }}>Tutar</th>
                <th style={{ padding: "14px 16px", textAlign: "right", width: "8%", borderRight: "4px solid #f1f5f9" }}>Oran</th>
                
                <th style={{ padding: "14px 16px", textAlign: "left", width: "30%" }}>PASİF (Öz Kaynaklar & Borçlar)</th>
                <th style={{ padding: "14px 16px", textAlign: "right", width: "12%" }}>Tutar</th>
                <th style={{ padding: "14px 16px", textAlign: "right", width: "8%" }}>Oran</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} style={{ borderBottom: row.left.name === "AKTİF TOPLAM" ? "none" : "1px solid #f1f5f9" }}>
                  
                  {/* SOL TARAF (Aktif) */}
                  <td style={{ padding: "10px 16px", fontWeight: row.left.bold ? "bold" : "normal", color: row.left.highlight ? "#ef4444" : "#1e293b", background: row.left.highlight ? "#fef2f2" : "transparent", whiteSpace: "pre" }}>{row.left.name}</td>
                  <td style={{ padding: "10px 16px", textAlign: "right", fontWeight: row.left.bold ? "bold" : "500", background: row.left.highlight ? "#fef2f2" : "transparent" }}>{row.left.amount !== null ? money(row.left.amount) : ""}</td>
                  <td style={{ padding: "10px 16px", textAlign: "right", color: "#64748b", borderRight: "4px solid #f1f5f9", background: row.left.highlight ? "#fef2f2" : "transparent" }}>{row.left.ratio ? percent(row.left.amount, row.left.ratio) : ""}</td>
                  
                  {/* SAĞ TARAF (Pasif) */}
                  <td style={{ padding: "10px 16px", fontWeight: row.right.bold ? "bold" : "normal", color: row.right.highlight ? "#10b981" : "#1e293b", background: row.right.highlight ? "#f0fdf4" : "transparent", whiteSpace: "pre" }}>{row.right.name}</td>
                  <td style={{ padding: "10px 16px", textAlign: "right", fontWeight: row.right.bold ? "bold" : "500", background: row.right.highlight ? "#f0fdf4" : "transparent" }}>{row.right.amount !== null ? money(row.right.amount) : ""}</td>
                  <td style={{ padding: "10px 16px", textAlign: "right", color: "#64748b", background: row.right.highlight ? "#f0fdf4" : "transparent" }}>{row.right.ratio ? percent(row.right.amount, row.right.ratio) : ""}</td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}